<mat-card-header>
  <mat-toolbar class="toolbar">
    <mat-card-title style="font-size: 20px; font-weight: bold; font-family: 'Inter', 'Roboto', 'Outfit', sans-serif; margin: 0;">{{ 'reservationList' | translate }} {{voyageid}}</mat-card-title>
    <span class="toolbar-spacer"></span>

    <div class="header-button-group">
      <button mat-mini-fab title="{{ 'ajouteReservation' | translate }} "
       (click)="addReservation()">
        <mat-icon >perm_contact_calendar</mat-icon>
      </button>
    </div>
  </mat-toolbar>
</mat-card-header>

<div class="container">
  <div class="filter-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutGap="10px" style="margin-bottom: 16px; flex-wrap: wrap; width: 100%;">
    <mat-form-field appearance="outline" fxFlex="40" style="margin-bottom: 0;">
      <mat-icon matPrefix style="color: var(--primary-color); margin-right: 8px;">search</mat-icon>
      <input matInput [(ngModel)]="searchCriteria.nomclient" (ngModelChange)="onCriteriaChange()"
        placeholder="Rechercher par nom du client..." />
    </mat-form-field>

    <button type="button" mat-stroked-button (click)="toggleAdvancedSearch()" style="height: 48px; border-radius: 8px;">
      <mat-icon>{{ searchCriteria.showAdvanced ? 'expand_less' : 'expand_more' }}</mat-icon>
      Recherche Avancée
    </button>

    <button type="button" mat-button *ngIf="searchCriteria.showAdvanced" (click)="resetCriteria()" style="height: 48px; border-radius: 8px;">
      Réinitialiser
    </button>

    <span style="flex: 1 1 auto;"></span>

    <app-table-config 
      tableKey="reservation_table" 
      [allColumns]="allColumns" 
      [(displayedColumns)]="displayedColumns">
    </app-table-config>
  </div>

  <div *ngIf="searchCriteria.showAdvanced" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px" style="margin-bottom: 16px; flex-wrap: wrap; background: rgba(0,0,0,0.03); padding: 12px; border-radius: 8px; width: 100%;">
    <mat-form-field appearance="outline" fxFlex="23">
      <mat-label>Contact/Téléphone</mat-label>
      <input
        matInput
        [(ngModel)]="searchCriteria.contact"
        (ngModelChange)="onCriteriaChange()"
        placeholder="Téléphone"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="23">
      <mat-label>N° Siège</mat-label>
      <input
        matInput
        [(ngModel)]="searchCriteria.place"
        (ngModelChange)="onCriteriaChange()"
        placeholder="Siège"
      />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="23">
      <mat-label>Code Voyage</mat-label>
      <input
        matInput
        [(ngModel)]="searchCriteria.voyageNumero"
        (ngModelChange)="onCriteriaChange()"
        placeholder="Voyage"
      />
    </mat-form-field>
  </div>

  <!-- table display content here-->
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

         <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
          <td mat-cell *matCellDef="let element; let i=index;"> {{i+1}} </td>
        </ng-container>

           <!-- Name Column -->
          <ng-container matColumnDef="ticket">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'ticket' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.idreservation}} </td>
         </ng-container>

           <!-- Name Column -->
          <ng-container matColumnDef="passager">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'reservation' | translate}} </th>
              <td mat-cell *matCellDef="let row"> {{row.nomclient}} </td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.phone' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.contact}} </td>
          </ng-container>

          <ng-container matColumnDef="destination">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'destination' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.voyage.destination[0]?.ville?.nomville}} </td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'category' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.voyage.category.nomcategory}} </td>
          </ng-container>

          <ng-container matColumnDef="bus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.bus' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.voyage.busname==null?row.voyage.nomvoyage:row.voyage.busname}} </td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Date' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.creationdate | date:"dd-MM"}} </td>
          </ng-container>

          <ng-container matColumnDef="tarif">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.tarif' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.voyage.tarif.tarif}} </td>
          </ng-container>

          <ng-container matColumnDef="siege">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'siege' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.place}} </td>
          </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> {{'action' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="actionMenu" [matMenuTriggerData]="{element: element}">
            <mat-icon style="color: var(--primary-color);">more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <mat-menu #actionMenu="matMenu">
        <ng-template matMenuContent let-element="element">
          <!-- valider -->
          <button mat-menu-item (click)="getreservationdata(element)">
            <mat-icon style="color: green;">check_circle</mat-icon>
            <span>Valider la réservation</span>
          </button>
          
          <!-- supprimer -->
          <button mat-menu-item (click)="delete(element)">
            <mat-icon style="color: red;">cancel</mat-icon>
            <span>{{ 'supprimer' | translate }}</span>
          </button>
        </ng-template>
      </mat-menu>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No records found.
        </td>
      </tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"  ></tr>
        <tr class="example-element-row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 100,reservationlist?.totalElements]" (page)="nextPage($event)" [length]="reservationlist?.totalElements"
    showFirstLastButtons></mat-paginator>
  </div>

</div>
